module.exports = __webpack_public_path__ + "static/media/inlock.60eb9a06.svg";